// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Hcur","questions":"styles_questions__a0o0I","footer":"styles_footer__1wgea"};